import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AudioPlayer from 'src/components/ui/GlobalComponents/AudioPlayer/AudioPlayer';
import Divider from 'src/components/ui/GlobalComponents/Divider/Divider';
import useUser from 'src/hook/data/useUser';
import { useShare } from 'src/hook/global/useShare';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { Examples } from 'src/model/enum/enums';
import { Word } from 'src/model/Word';
import { GetRazorSiteUrl, GetWebSiteUrl, IconLocation, ImageLocation } from 'src/utils/URLUtils';
import styles from './FooterIcons.module.scss';



interface FooterIconsProps {
    imageUrl: string;
    definition: string;
    title: string;
    videoUrl: string;
    type: Examples;
    word: Word;
    quoteId: string;
    authorId: string;
}

const FooterIcons: React.FC<FooterIconsProps> = ({ imageUrl, definition, title, videoUrl, type, word, quoteId, authorId }) => {
    const { share, isLoading } = useShare();
    const footerRef = useRef<HTMLDivElement>(null);
    const { open } = useIFrameModal();
    const { userInfo } = useUser();
    const { t } = useTranslation();

    const handleExplain = () => {
        let text;
        if (type === Examples.Quotes) {
            text = `What is the meaning of this quote by ${title}: \n\n ${definition}.`;

        }
        else {
            text = `Explain this: \n\n ${definition}`;
        }

        const queryString = `wordId=${word.ID}&lexi=${encodeURIComponent(text)}`;
        open(GetRazorSiteUrl(`practice/word-chat`, userInfo?.Token, queryString)
            , `Discuss '${word.Text}'`);

    }
    const handleDiscuss = () => {

        let queryString = `wordId=${word.ID}`;
        if (type === Examples.Quotes) {
            queryString += `&quoteId=${quoteId}&personId=${authorId}&lexi=${encodeURIComponent(definition)}`;
        }
        else {
            queryString += `&personId=0&lexi=${encodeURIComponent(definition)}`;
        }


        open(GetRazorSiteUrl(`practice/fantasy-chat`, userInfo?.Token, queryString)
            , title);
    }


    const handleShare = () => {
        // Get the previous sibling element (Quote component)
        const quoteElement = footerRef.current?.previousElementSibling?.previousElementSibling as HTMLElement;
        const text = imageUrl ? `${title} : ${definition} \n ${GetWebSiteUrl()}` : `Via WordUp Vocabulary \n ${videoUrl}`;
        share(text, quoteElement);
    };

    return (
        <>
            <Divider noMargin={true} />
            <div className={styles.footerIcons} ref={footerRef} >
                {imageUrl && (
                    <>
                        <div className={styles.iconDiv}>
                            <AudioPlayer text={definition} imageSize='25px' />
                            <span className={styles.label}>{t('Listen')}</span>
                        </div>

                        <div className={styles.iconDiv} onClick={handleExplain}>
                            <img src={ImageLocation('Lexi/Lexi-General.png')}
                                alt="Explain" className={styles.icon} />
                            <span className={styles.label}>{t('Explain')}</span>
                        </div>

                        <div className={styles.iconDiv} onClick={handleDiscuss}>
                            <img src={imageUrl} alt="Discuss" className={styles.icon} />
                            <span className={styles.label}>{t('Discuss')}</span>
                        </div>
                    </>
                )}

                <div className={styles.iconDiv} onClick={handleShare}>
                    <img src={IconLocation('share')} alt="Share"
                        className={`${styles.icon} ${isLoading ? styles.zoom : ''}`} />
                    <span className={styles.label}>{t('Share')}</span>
                </div>
            </div>
            <Divider thick={true} noMargin={true} />
        </>
    );
};

export default FooterIcons;